/* global window, g */

import _ from 'underscore';
import Backbone from 'backbone';

"use strict";

// Address

var Address = Backbone.Model.extend({
  urlRoot: g.urlRoot + "/address"
});

var AddressCollection = Backbone.Collection.extend({
  initialize: function (models, options) {
    options = options ? _.clone(options) : {};
    if (options.org) {
      this.org = options.org;
    }
    if (options.event) {
      this.event = options.event;
    }
  }
});

export {
  AddressCollection,
};
